@if (selectedCount > 0) {
  <div class="app-activity-search-engine-panel__selected-count-label">
    <mat-icon svgIcon="app-activity-search-engine-panel__selected-count-label__icon"></mat-icon>
    <span>{{ selectedCount }} {{ 'activity_search.selected_count_label' | translate }}</span>
  </div>
  <button
    (click)="onClearSelection($event)"
    class="app-activity-search-engine-panel__clear-selection-button"
    type="button">
    <span>{{ 'activity_search.clear_selection_button' | translate }}</span>
  </button>
  <button
    (click)="onValidateSelection($event)"
    class="app-activity-search-engine-panel__validate-selection-button"
    type="button">
    <mat-icon
      class="app-activity-search-engine-panel__validate-selection-button__icon"
      svgIcon="app-activity-search-engine-panel__validate-selection-button__icon"></mat-icon>
    {{ 'activity_search.validate_selection_button' | translate }}
  </button>
}
